import type { JSX } from "react";

import {
    IBasket,
    IBasketLine,
    IOptionCode,
    IProduct,
    IWishListLine,
} from "../../../models/catalogue.interfaces";
import { notEmpty } from "../../../utils/functional";
import { Actions } from "../actions";

export interface IBasketLineBaseProps<T = IBasketLine | IWishListLine> {
    line: T;
    shippingMethodCode?: string;
}

export type TProductUpsell = {
    placement: "in-details" | "post-details";
    hideBottomBorder?: boolean;
    content: JSX.Element;
};

export type TGetProductUpsell = (
    basket: IBasket,
    line: IBasketLine,
    addBasketLine: Actions["addBasketLine"],
) => TProductUpsell | null;

export const listOptions = (
    product: IProduct,
): Array<{
    key: IOptionCode;
    name: string;
    value: string | string[];
}> => {
    const attributes = product.attributes;
    const optionKeys = attributes.product_options?.value || [];
    return optionKeys
        .map((key) => {
            const attr = attributes[key];
            if (!attr) {
                return;
            }
            return {
                key: key,
                name: attr.name,
                value: attr.value,
            };
        })
        .filter(notEmpty);
};
